import type { AnalyticsEvent } from '@types'
import type { IRogue } from '@/js/services/RogueTypes'

export const initClickTracking = (rogue: IRogue): void => {
  document.addEventListener('click', (e: MouseEvent) => {
    const el = e.target
    if (el && el instanceof HTMLElement) {
      const trackable = el.closest('[data-track]')
      if (trackable) {
        const location = trackable.getAttribute('data-track')!
        const elementKey = trackable.getAttribute('data-index')!
        const link = el instanceof HTMLAnchorElement ? el : el.closest('a')
        const input = location === 'Site Search' ? document.getElementById('search-bar-input') : null
        const url = link ? link.getAttribute('href') : undefined
        const search = input && input instanceof HTMLInputElement ? input.value : null
        const text = el.innerText
        const alt = el.getAttribute('alt')
        if (!url && !text && !alt && !search) {
          return
        }
        const payload: AnalyticsEvent = { type: 'elClick', el, location }
        if (url) {
          payload.link = url
        }
        if (text) {
          payload.text = text.substring(0, 19)
        }
        if (alt) {
          payload.alt = alt
        }
        if (search) {
          payload.search = search
        }
        if (elementKey) {
          payload.elementKey = elementKey
        }

        rogue.track.track(payload)
      }
    }
  })
}
